export interface CountReflectionInterface {
  count: number
  studentCount: number
  teacharCount: number
  names: string[]
}

export class CountReflection implements CountReflectionInterface {
  count: number
  studentCount: number
  teacharCount: number
  names: string[]

  constructor(props: CountReflectionInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      count: _count,
      studentCount: _studentCount,
      teacharCount: _teacharCount,
      names: _names,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.count = _count
    this.studentCount = _studentCount
    this.teacharCount = _teacharCount
    this.names = _names
  }
}
